<template>
  <div class="equipment-details">
    <h4>Equipment and performance charts</h4>
    <AIParametersPreview v-if="scenario && sizing && option.sizingDraft" :key="option.traceId || option.priority" :option="option" :scenario="scenario" :sizing="sizing">
      <template #assessment>
        <p>{{ descriptions[option.priority] }}</p>
        <AIOptionSummary :pros="option.pros" :cons="option.cons" />
      </template>
    </AIParametersPreview>
    <template v-else>
      <EquipmentDetailsTabs :equipment="option.equipment" :issues="issues" />
      <AIOptionSummary :pros="option.pros" :cons="option.cons" />
    </template>
  </div>
</template>
<script setup lang="ts">
import { defineAsyncComponent } from "vue";
import type { Scenario, Sizing } from "@/composables/forms/formTypes";
import type { AIEquipmentSuggestionOption, AIEquipmentIssue } from "@/libs/api/aiEquipmentSuggestions";
import AIOptionSummary from "./AIOptionSummary.vue";
import EquipmentDetailsTabs from "@/components/EquipmentDetailsTabs.vue";
const AIParametersPreview = defineAsyncComponent(() => import('./AIParametersPreview.vue'));
defineProps<{ option: AIEquipmentSuggestionOption; scenario?: Scenario | null; sizing?: Sizing | null; issues?: AIEquipmentIssue[] }>();
const descriptions = {
  performance: 'Performance-focused candidate from a bounded search; maximum efficiency is not established.',
  runlife: 'Run-life-focused candidate; operating reserves do not predict service life.',
  cost: 'Cost-focused candidate using sizing proxies; live prices are not verified.'
};
</script>
